import React from 'react';
import { StyleSheet, View, } from 'react-native';
import Animated from 'react-native-reanimated';
import emoji from 'node-emoji';
import { useAppSelector } from 'store/hooks';
import { AppView, CardView, IconClose, rem, SCROLL_INDICATOR_INSETS, SettingsItemNavigate, } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import IconCircle from 'design-system/icons/IconCircle';
import { IconDots } from 'design-system/icons/IconDots';
import Logo from 'design-system/Logo';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { CompetitorId } from 'features/premium/entities';
const APPS_GB = [
    {
        id: CompetitorId.Snoop,
        name: 'Snoop',
        logo: require('../img/snoop.png'),
    },
    {
        id: CompetitorId.MoneyDashboard,
        name: 'Money Dashboard',
        logo: require('../img/moneydashboard.png'),
    },
    {
        id: CompetitorId.YNAB,
        name: 'YNAB',
        logo: require('../img/ynab.png'),
    },
    {
        id: CompetitorId.Plum,
        name: 'Plum',
        logo: require('../img/plum.png'),
    },
    {
        id: CompetitorId.Chip,
        name: 'Chip',
        logo: require('../img/chip.png'),
    },
    {
        id: CompetitorId.Monzo,
        name: 'Monzo',
        logo: require('../img/monzo.png'),
    },
    {
        id: CompetitorId.Curve,
        name: 'Curve',
        logo: require('../img/curve.png'),
    },
];
const APPS_US_CA = [
    {
        id: CompetitorId.RocketMoney,
        name: 'Rocket Money',
        logo: require('../img/rocketmoney.png'),
    },
    {
        id: CompetitorId.YNAB,
        name: 'YNAB',
        logo: require('../img/ynab.png'),
    },
    {
        id: CompetitorId.MonarchMoney,
        name: 'Monarch Money',
        logo: require('../img/monarchmoney.png'),
    },
    {
        id: CompetitorId.Copilot,
        name: 'Copilot',
        logo: require('../img/copilot.png'),
    },
    {
        id: CompetitorId.EveryDollar,
        name: 'EveryDollar',
        logo: require('../img/everydollar.png'),
    },
];
const SelectCompetitorApp = ({ title, onPressApp, onPressOther, scrollHandler, }) => {
    const guessedHomeCountry = useAppSelector((store) => store.user.user.guessedHomeCountry);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT + rem(16), paddingHorizontalStyle);
    const colors = useColors();
    return (<AppView withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <Animated.ScrollView onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={paddingBottom}>
        <ScreenInfoHeader title={title} subTitle={emoji.emojify('Choose an option :point_down:')}/>
        <CardView noMarginTop>
          {(guessedHomeCountry === 'GB' ? APPS_GB : APPS_US_CA).map((app) => (<SettingsItemNavigate key={app.name} title={app.name} onPress={() => onPressApp(app.name, app.id)} renderIcon={() => (<View style={styles.logo}>
                  <Logo R44 uri={app.logo} withOutline resizeMode="contain" internalPadding={app.name === 'YNAB' || app.name === 'Copilot'}/>
                </View>)}/>))}
          <SettingsItemNavigate title="No other app" renderIcon={() => (<View style={styles.logo}>
                <IconCircle width={44} height={44}>
                  <IconClose alt color={colors.elements.negative}/>
                </IconCircle>
              </View>)} onPress={onPressApp}/>
          <SettingsItemNavigate title="Other" onPress={onPressOther} renderIcon={() => (<View style={styles.logo}>
                <IconCircle width={44} height={44}>
                  <IconDots gradientKey="ultimate"/>
                </IconCircle>
              </View>)}/>
        </CardView>
      </Animated.ScrollView>
    </AppView>);
};
const styles = StyleSheet.create({
    logo: {
        marginRight: rem(16),
    },
});
export default SelectCompetitorApp;
